import { createAction } from '@reduxjs/toolkit';

export const requestViewActivityEngagement = createAction('request/viewActivityEngagement');
export const requestViewHashtagEngagement = createAction('request/viewHashtagEngagement');
export const requestViewHashtagOccurrences = createAction('request/viewHashtagOccurrences');
export const requestUploadAnswers = createAction('request/uploadAnswers');
